<template>
<div>
    <el-form ref="form" :model="addPersonform" :rules="rules" label-width="80px"> 
        <el-form-item label-width="120px" label="姓名：" style="margin: 30px">
            <el-input class="win" v-model="addPersonform.name"></el-input>  
        </el-form-item> 
        <el-form-item label-width="120px" label="手机号码：" style="margin: 30px" prop="phone">
            <el-input class="win" v-model="addPersonform.phone"></el-input>  
        </el-form-item>  
        <el-form-item label-width="120px" label="地址：" style="margin: 30px" prop="address" >
            <div style="box-sizing: border-box;">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-select
                    @change="onStreetIdChange"
                    v-model="addPersonform.province"
                    placeholder="请选择街道"
                  >
                    <el-option label="天长市" :value="21"></el-option> 
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select @change="onCommitteeIdChange" v-model="addPersonform.city" clearable placeholder="请选择社区">
                    <el-option v-for="item in committeeIds" :key="item.id" :label="item.label" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="addPersonform.gridId" clearable @change="businessTypeChange" placeholder="请选择网格">
                    <el-option v-for="item in gridIds" :key="item.id" :label="item.label" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button size="mini" type="success" @click="chooseGrid">选定网格</el-button>
                </el-form-item>
                <el-form-item>
                    <el-input class="win" v-model="addPersonform.address" v-show="addPersonform.address"></el-input>  
                </el-form-item>
              </el-form>
              <div id="container" style="width: 93%;height: 239px;"></div>
            </div>
        </el-form-item>  
        
        <!-- <el-form-item label-width="120px" label="人员住址" style="margin: 30px">
          <div class="lablewid">
            <el-select class="lablewid_input" v-model="addPersonform.province" style="margin-right: 20px;" placeholder="请选择" >
              <el-option label="天长市" value="1"></el-option>
            </el-select>
            <el-select class="lablewid_input"  style="margin-right: 20px;"  @change="getAddressByParentId" v-model="addPersonform.city" placeholder="请选择">
              <el-option label="浔河社区" value="2"></el-option>
              <el-option label="石街社区" value="20"></el-option>
            </el-select>   
            <el-select v-model="gridId" placeholder="--选择网格--" style="width:174px">
              <el-option v-for="item in gridCode" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
            </el-select>   
          </div>
          <div class="lablewid">
            <el-input class="win" v-model="addPersonform.address" @blur="transLocation"></el-input> 
          </div> 
          <div>
            <div id="container"  class="win" style="height:200px;margin-bottom: 50px;"></div>
          </div>
        </el-form-item>  -->
        <el-form-item label-width="120px" label="所属组织" style="margin: 30px">
            <el-select class="win" v-model="addPersonform.consultOrgId" placeholder="请选择">
              <el-option v-for="item in consultNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>  
        </el-form-item>   
    </el-form>
    <div class="boontbtn">
      <el-button type='primary' size='small' @click='createData' style='margin: 0 30px'>保存</el-button>
    </div>
</div>
</template>

<script>
import request from "@/utils/request.js";
import { getConsulTYpePersion, getTypeById_p } from "@/api/http.js";
import { post } from "@/api/requrestHttp";
import AMap from "AMap"; // 引入高德地图 
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "ViewPeople",
  props: ["choosedata", "isshow", "personTypeF","tableInfo"],
  data() {
    return {
      rules: {  
          phone:
          [{ required: true,message: '请输入手机号码',trigger: 'blur'},
            {validator:function(rule,value,callback){
                  if(/^1[34578]\d{9}$/.test(value) == false){
                      callback(new Error("请输入正确的手机号"));
                  }else{
                      callback();
                  }
              }, trigger: 'blur'}],
      },
      addPersonform: {
          name: '',
          sex: '',
          age: '',
          phone: '',
          remarks: ''
        },
      options: [{
          value: '0',
          label: '男'
        }, {
          value: '1',
          label: '女'
        }],
      //人员类别
      gridId:'',
      searchGroups: [],
      searchGroupsChild: [],
      searchlist: {},
      tableData: [],
      multipleSelection: {},
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }, 
      committeeIds: [],
      gridIds: [],
      gridCode: [] ,
      getRowKey(row) {
        return row.id;
      },

      checkSelectable(row) {
        return true;
      },
      checkedData: [],
      currentPageData: [],
      multipleSelectionFarher: {},
      multipleSelectionClick: {},
      consultNameList: []
      //   surplusData: []
    };
  },
  methods: { 
    //根据输入地址转换经纬度并标记
    // transLocation() {
    //     var searchKey = this.addPersonform.address;
    //     var map = new AMap.Map("container", {
    //         resizeEnable: true,
    //         zoom: 18,
    //     });
    //     var that = this;
    //     AMap.plugin("AMap.Geocoder", function () {
    //         var geocoder = new AMap.Geocoder({
    //             radius: 1000,
    //             extensions: "all",
    //         });
    //         var marker = new AMap.Marker();
    //         geocoder.getLocation(searchKey, function (status, result) {
    //             if (status === "complete" && result.geocodes.length) {
    //                 var lnglat = result.geocodes[0].location;
    //                 that.addPersonform.longitude = String(lnglat.lng);
    //                 that.addPersonform.latitude = String(lnglat.lat);
    //                 console.log("that.addPersonform=>", that.addPersonform);
    //                 marker.setPosition(lnglat);
    //                 map.add(marker);
    //                 map.setFitView(marker);
    //             } else {
    //                 that.$message({
    //                     message: "获取坐标失败，请手动获取",
    //                     type: "error",
    //                 });
    //                 that.mapInit("container");
    //             }
    //         });
    //         map.on("click", function (e) {
    //             that.addPersonform.longitude = String(e.lnglat.getLng());
    //             that.addPersonform.latitude = String(e.lnglat.getLat());
    //             geocoder.getAddress(
    //                 e.lnglat.getLng() + "," + e.lnglat.getLat(),
    //                 function (status, result) {
    //                     console.log(status);
    //                     if (status === "complete" && result.regeocode) {
    //                         var address = result.regeocode.formattedAddress;
    //                         that.$set(that.addPersonform, "address", address);
    //                     } else {
    //                         log.error("根据经纬度查询地址失败");
    //                     }
    //                 }
    //             );
    //         });
    //     });
    // },
    //初始化地图插件的方法
    mapInit(containerId) { 
        var map = new AMap.Map(containerId, {
            resizeEnable: true,
            zoom: 18,
            zooms: [3, 20],
            expandZoomRange: true,
            center: [119.013268,32.6739],
        });
        this.map = map
        console.log(map);
        if (this.addPersonform.longitude && this.addPersonform.latitude) {
            var marker = new AMap.Marker({
                position: [
                    Number(this.addPersonform.longitude),
                    Number(this.addPersonform.latitude),
                ],
                map: map,
            });
            map.setFitView(marker);
        } else {
            AMap.plugin("AMap.Geolocation", function () {
                //异步定位当前
                var geolocation = new AMap.Geolocation();
                map.addControl(geolocation);
            });
        } //定义地图坐标点击事件
        var that = this;
        var geocoder = new AMap.Geocoder({
            city: "010", //城市设为北京，默认：“全国”
            radius: 1000, //范围，默认：500
        });
        map.on("click", function (e) { 
            that.addPersonform.longitude = String(e.lnglat.getLng());
            that.addPersonform.latitude = String(e.lnglat.getLat());
            geocoder.getAddress(
                e.lnglat.getLng() + "," + e.lnglat.getLat(),
                function (status, result) {
                    if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress;
                        that.$set(that.addPersonform, "address", address);
                    } else {
                        log.error("根据经纬度查询地址失败");
                    }
                }
            );
        });
    },
    reset() {
      this.addPersonform = {};
      this.addPersonform.gridId = ''; 
    },
    // 获取地址下拉
    getAddressByParentId(val) { 
      // console.log(val);  
    },
    // 获取人员所属组织
    getConsultName() {
      post("admin/consulOrg/info/listConsultOrg",{
        pageNo: 1,
        pageSize: 1000,
        status:0,
      }).then(res => {
        this.consultNameList = res.content.list;
        console.log(this.consultNameList);
      })
      this.$nextTick(() => {
          this.mapInit("container");
      })
    },
    //获取人员类别树状图
    async getPTypes() {
      var res = await getTypeById_p({
        pageNo: 1,
        pageSize: 9999,
        parentId: 0
      });
      //   console.log(res);

      if (res.content && res.content.list.length) {
        this.searchGroups = res.content.list || [];

        this.personTypeChange(this.personTypeF);
      }
    },


// 网格地图选址start
    //初始化地图插件的方法
    mapSuccess(info) {
      this.mapData = info;
    },
    // 选择街道
    async onStreetIdChange(val) {
      post("/admin/org/info/list", {
        // regionFlag: val,
        orgLevel: 3,
      }).then((res) => {
        if (res.code == "200") {
          this.committeeIds = res.content;
        }
      }); 
    },
    businessTypeChange(item){

        this.$forceUpdate()

        console.log(item);

      },
    // 选择网格
    async onCommitteeIdChange(val) {
      this.addPersonform.gridId = '' 
      console.log("*")
      // 网格选项改变
      this.gridIds = [];
      if (val != null) {
        post("/admin/org/info/getSubRegionGrid", {
          id: val, 
        }).then((res) => {
          if (res.code == "200") {
            this.gridIds = res.content; 
          }
        });  
        return this.gridIds;
      }
    },
    // 显示地图
    chooseAddress() {
      console.log(1);
    }, 
    // 选定网格
    chooseGrid() {
      // 获取网格id
      const gridId = this.addPersonform.gridId

      // pointPosition
      // 获取网格范围
      let pointPosition = ''
      this.gridIds.forEach(item => {
        if (item.id == gridId) {
          pointPosition = item.pointPosition
        }
      })
      if (!pointPosition) {
        this.$message({
          message: '该网格暂无坐标信息',
          type: 'error'
        })
      } else {
        const arr = pointPosition.split(',')
        var polygonArr = []
        arr.forEach(item => {
          const arr2 = item.split(':')
          const arr3 = [arr2[0], arr2[1]]
          polygonArr.push(arr3)
        })
        console.log(polygonArr);
        // 如果已经存在 直接设置
        if (this.polygon) {
          this.polygon.setPath(polygonArr)
        } else {
          var polygon = new AMap.Polygon({
            map: this.map,
            path: polygonArr, //设置多边形边界路径
            strokeColor: "#FF33FF", //线颜色
            strokeOpacity: 0.2, //线透明度
            strokeWeight: 3, //线宽
            fillColor: "#FF33FF", //填充色
            fillOpacity: 0.35, //填充透明度
          });
          this.polygon = polygon
        }
        this.map.setZoom(16)
        this.map.setCenter(polygonArr[0])
        // 设置点击事件
        this.polygon.on('click', (e) => {
          this.addPersonform.longitude = e.lnglat.getLng();
          this.addPersonform.latitude = e.lnglat.getLat();
          if (this.mapmarker) {
            this.mapmarker.setPosition([this.addPersonform.longitude, this.addPersonform.latitude])
          } else {
            this.mapmarker = new AMap.Marker({
              position: [this.addPersonform.longitude, this.addPersonform.latitude],
              map: this.map
            });
          }
        })
      }
      console.log(pointPosition)
    },
// 网格地图选址end

    //改变状态
    async personTypeChange(ids) {
      let res = await getTypeById_p({
        parentId: ids,
        pageSize: 9999,
        pageNo: 1
      });
      this.$set(this.searchlist, "parentPersonTypeId", ids);
      this.$set(this.searchlist, "personTypeId", "");
      if (res.content) {
        this.searchGroupsChild = res.content.list || [];
      }
      //   this.getPageDatas();
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.checkedData = [];
      this.multipleSelection = {};
      this.multipleSelectionFarher = {};
      this.multipleSelectionClick = {};
      this.tableData = [];
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      // this.$nextTick(() => {
      //   this.$refs.multipleTablePeo.clearSelection();
      // });

      var res = await getConsulTYpePersion({
        ...this.searchlist,
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
      });

      // console.log(res)
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;

        if (res.content) {
          // 取出当前页数的选中table数据
          let hadTableData = [];
          if (this.choosedata && this.choosedata.length) {
            this.choosedata.forEach(row => {
              res.content.list.forEach(row1 => {
                if (row.id == row1.id) {
                  //   this.checkedData.push(row1);
                  hadTableData.push(row1);
                }
              });
            });
          }

          this.multipleSelectionFarher[this.pageConfig.pageNo] = hadTableData;
          //   第一次显示父级传进来的数据的回显,如果有选中则以实际为准
          //   console.log(this.multipleSelectionClick[this.pageConfig.pageNo]);
          if (!this.multipleSelectionClick[this.pageConfig.pageNo]) {
            this.multipleSelection[this.pageConfig.pageNo] = hadTableData;
          }

          let newpagedata = [];
          res.content.list.forEach(row1 => {
            this.multipleSelection[this.pageConfig.pageNo].forEach(row2 => {
              if (row1.id == row2.id) {
                //   this.checkedData.push(row1);
                newpagedata.push(row1);
              }
            });
          });
          this.multipleSelection[this.pageConfig.pageNo] = newpagedata;
          this.checkedData = newpagedata;
          this.checkedTable();
        }
      } else {
        // console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    checkedTable() {
      //   console.log("checkedData==t", this.checkedData);
      this.$nextTick(() => {
        this.checkedData.forEach(checked => {
          this.$refs.multipleTablePeo.toggleRowSelection(checked, true);
        });
      });
    },
    getDetail(){
      let _this = this
      this.$forceUpdate()
      this.addPersonform = {}
      if(this.tableInfo.province && this.tableInfo.city && this.tableInfo.area) {
        this.onStreetIdChange()
        this.onCommitteeIdChange(this.tableInfo.city)
        this.businessTypeChange()
        setTimeout(() => {
          _this.chooseGrid()
        },1000)
      }
      console.log(this.tableInfo,'info')
      this.addPersonform = this.tableInfo
      this.addPersonform.province && (this.addPersonform.province = Number(this.addPersonform.province))
      this.addPersonform.city && (this.addPersonform.city = Number(this.addPersonform.city))
      this.addPersonform.area && (this.addPersonform.gridId = Number(this.addPersonform.area))
    },
    handleSelectionsChange(val) {
      this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1;
      this.multipleSelection[this.pageConfig.pageNo] = val;
      //   this.currentPageData = val;
    },
    selectionChange(val) {
      // console.log(val);
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    }, 
    //封装数据
    createData() {
      console.log(this.addPersonform)
      this.$emit("func", this.addPersonform); 
    }
  },
  computed: {
    disabledType() {
      if (this.personTypeF) return true;
      return false;
    }
  },
  mounted() { 
    if(this.map){
      this.map.destroy()
    }
    console.log(this.tableInfo,'ceshi')
    this.getConsultName(); 
    this.$nextTick(() => {
      this.mapInit("container");  
    })
    
  },
  created() {
    this.searchlist.parentPersonTypeId = this.personTypeF;
    this.getPTypes();
    this.getPageDatas();
  },
  watch: {
    choosedata(val) {
      if (val && val.length) {
        // val.forEach(row => {
        //   this.$nextTick(function() {
        //     this.$refs.multipleTablePeo.toggleRowSelection(row);
        //   });
        // });
      } else {
        // this.$refs.multipleTablePeo.clearSelection();
      }
    },
    isshow(val) {
      if (!val) {
        this.checkedData = [];
        this.multipleSelection = {};
        this.multipleSelectionFarher = {};
        this.multipleSelectionClick = {};
        this.searchlist = {};
        this.tableData = [];
        this.pageConfig.pageNo = 1;
      } else {
        this.searchlist.parentPersonTypeId = this.personTypeF;
        this.getPTypes();
        this.getPageDatas();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.win{
  width: 648px;
}
// .lablewid{
//   width: 680px;
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 15px;
// } 
</style>